export class GoToActiveTabEvent {}
